export default __webpack_public_path__ + "static/media/shortExpiry.957e14fb.svg";